<template>
    <div class="bill">
        <DropdownMenu>
            <DropdownItem :title="form.monthTime ? getTimes(form.monthTime, 'YYYY-MM') : '选择时间'" ref="time">
                <DatetimePicker
                    @cancel="cancel"
                    @confirm="confirm"
                    v-model="currentDate"
                    cancel-button-text="清空"
                    type="year-month"/>
            </DropdownItem>
            <DropdownItem v-model="form.type" @change="formTypeChange" :options="typeList"/>
        </DropdownMenu>
        <a href="tel:400-066-5298" v-if="!isStore">
            <img src="../../../assets/images/ic_bill_service.png" class="service"/>
        </a>
        <List v-model="listLoading" :finished="finished" finished-text="没有更多了" @load="getList">
            <div class="listItem" v-for="(item, index) in list" :key="index" @click="onItemClick(item)">
                <p class="time van-hairline--bottom">{{item.createTime}}</p>
                <div class="listItemBottom">
                    <div class="listItemTitle">
                        <span>{{billType[item.sourceType]}}{{item.sourceType === 'RECORD_DRAW' ? typeStateObj[item.recordState] : ''}}</span>
                        <em>{{typeWay[item.recordWay]}}{{item.amount.toFixed(2)}}</em>
                    </div>
                    <div class="listInfo">
                        <span>订单号：{{item.sourceId}}</span>
                        <span>余额：{{item.amountAfter.toFixed(2)}}元</span>
                    </div>
                </div>
            </div>
        </List>
    </div>
</template>

<script>
    /*
    * 账单明细
    * */
    import {DropdownMenu, DropdownItem, DatetimePicker, List} from 'vant';
    import {getBillList} from "../../../api/bill";
    import {mapState} from 'vuex';

    export default {
        name: "Bill",
        components: {
            DropdownMenu,
            DropdownItem,
            DatetimePicker,
            List
        },
        data() {
            return {
                currentDate: new Date(),
                listLoading: false,
                finished: false,
                form: {
                    type: 'RECORD_DRAW',
                    monthTime: '',
                    page: 1
                },
                typeList: [
                    {value: 'RECORD_DRAW', text: '提现',},
                    // {value: 'RECORD_BOUGHT_OTHER_BANK', text: '异宝购买',},
                    // {value: 'RECORD_REGION_PROFIT', text: '区域收益',},
                    {value: 'ORDER_REFUND', text: '订单退款',},
                ],
                typeWay: {
                    'RECORD_WAY_REDUCE': '-￥',
                    'RECORD_WAY_INCREASE': '+￥',
                },
                billType: {
                    'RECORD_DRAW': '提现',
                    // 'RECORD_BOUGHT_OTHER_BANK': '异宝购买',
                    // 'RECORD_REGION_PROFIT': '区域收益',
                    'RECORD_PROFIT': '收益',
                    'ORDER_REFUND': '订单退款',
                },
                typeStateObj: {
                    RECORD_STATE_ING: '中',
                    RECORD_STATE_SUCCESS: '成功',
                    RECORD_STATE_FAILURE: '失败'
                },
                count: 0,
                list: []
            }
        },
        computed: {
            ...mapState(['isStore', 'userInfo'])
        },
        methods: {
            onItemClick(item) {
                if (item.sourceType !== 'RECORD_BOUGHT_OTHER_BANK') return;
                if (this.isStore) return;
                if (item.recordWay === 'RECORD_WAY_REDUCE') return this.toPage(`/billDetail/buy/${item.id}`);
                if (item.recordWay === 'RECORD_WAY_INCREASE') this.toPage(`/billDetail/sale/${item.id}`);
            },
            formTypeChange(value) {
                this.form.page = 1;
                this.list = [];
                this.getList();
            },
            cancel() {
                this.form.page = 1;
                this.list = [];
                this.$refs.time.toggle();
                this.form.monthTime = '';
                this.currentDate = new Date();
                this.getList();
            },
            confirm(value) {
                this.form.monthTime = this.getTimes(value, 'YYYY-MM');
                this.$refs.time.toggle();
                this.form.page = 1;
                this.list = [];
                this.getList();
            },
            getList() {
                getBillList(this.form).then(res => {
                    this.list = [...this.list, ...res.records];
                    // 加载状态结束
                    this.listLoading = false;
                    if (res.records.length < 10) {
                        // 数据全部加载完成
                        this.finished = true;
                        return;
                    }
                    this.form.page++;
                })
            }
        },

        mounted() {
            // 检查是否显示收益情况
            if (this.userInfo.orderDetail !== 'CLOSE') {
                this.typeList.push({value: 'RECORD_PROFIT', text: '收益',})
            }
        }
    }
</script>

<style lang='less' scoped>
    .bill {
        min-height: 100vh;
        background-color: #f7f7f7;

        .listItem {
            margin-top: 2.7vw;
            background-color: white;

            .time {
                height: 5.7vw;
                line-height: 5.7vw;
                text-indent: 5.2vw;
                font-size: 2.9vw;
                color: #999999;
            }

            .listItemBottom {
                padding: 0 5.2vw 0.5vw;

                .listItemTitle {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    height: 8vw;

                    span {
                        font-size: 3.7vw;
                        color: #333333;
                    }

                    em {
                        font-size: 5.3vw;
                        color: #fe8f51;
                    }
                }

                .listInfo {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    height: 5.5vw;
                    font-size: 3.2vw;
                    color: #a9a9a9;
                }
            }
        }

        .service {
            position: fixed;
            right: 2vw;
            top: 50%;
            width: 5.87vw;
            height: 5.87vw;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/mine/bill/Bill.vue